import styled from "styled-components";
import CustomInputComponent from "../common/customInputComponent";
import { InputComponentProps } from "../../types/types";
import DateModalComponent from "../detail/dateModalComponent";
import { useEffect, useState } from "react";
import PostModalComponent from "../detail/postModalComponent";
import MoveDateInputComponent from "../detail/MoveDateInputComponent";
import EnterpriseDateInputComponent from "./enterpriseDateInputComponent";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 90%;
`;
const InputBox = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: start;
  justify-content: space-between;
  margin-top: 2vw;
`;

const Title = styled.p`
  display: flex;
  width: 100%;
  font-size: 2.6vw;
  font-weight: 700;
  margin-top: 3vw;
  color: #ff7f3b;
`;

const FoldingButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 2vw;
  /* border: 1px solid #ff7f3b; */
  border-radius: 0.6vw;
  background-color: #ff7f3b;
  color: white;
  width: 100%;
  height: 4vw;
  font-size: 1.2rem;
  font-weight: 500;
`;

const FoldingBox = styled.div<{
  $isExpanded: boolean;
}>`
  display: ${(props) => (props.$isExpanded ? "flex" : "none")};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export default function InputInfoTab(props: any) {
  const { data, setData, onChangeInput } = props;
  const [isDateModalOpen, setIsDateModalOpen] = useState<boolean>(false);
  const formattedDate = /^(\d{4})(\d{2})(\d{2})$/;
  const [addressType, setAddressType] = useState();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isAddressExpended, setIsAddressExpended] = useState<boolean>(false);

  // 날짜 모달 열기 핸들러
  const dateHandleOpenModal = () => {
    setIsDateModalOpen(true);
  };

  // // 날짜 모달 닫기 핸들러
  const dateHandleCloseModal = () => {
    setIsDateModalOpen(false);
  };

  const deleteValue = () => {
    dateHandleCloseModal();
  };
  //주소 모달 열기 핸들러
  const postHandleOpenModal = (type: any) => {
    setAddressType(type);
    setIsModalOpen(true);
  };

  //주소 모달 닫기 핸들러
  const postHandleCloseModal = () => {
    setIsModalOpen(false);
  };

  // 주소 추가 입력 버튼
  const handleFoldingButton = () => {
    setIsAddressExpended(!isAddressExpended);
  };

  const postValueInput = (data: any) => {
    const addressString = `${data.address}${
      data.buildingName ? "" + data.buildingName : ""
    } `;
    if (addressType === "departure1") {
      setData((prev: any) => {
        const updatedData = { ...prev };
        updatedData.contractInfo.detailInfo.departureAddress1 = addressString;
        updatedData.contractInfo.detailInfo.departureZipCode1 = data.zonecode;
        return updatedData;
      });
    } else if (addressType === "departure2") {
      setData((prev: any) => {
        const updatedData = { ...prev };
        updatedData.contractInfo.detailInfo.departureAddress2 = addressString;
        updatedData.contractInfo.detailInfo.departureZipCode2 = data.zonecode;
        return updatedData;
      });
    } else if (addressType === "departure3") {
      setData((prev: any) => {
        const updatedData = { ...prev };
        updatedData.contractInfo.detailInfo.departureAddress3 = addressString;
        updatedData.contractInfo.detailInfo.departureZipCode3 = data.zonecode;
        return updatedData;
      });
    } else if (addressType === "destination1") {
      setData((prev: any) => {
        const updatedData = { ...prev };
        updatedData.contractInfo.detailInfo.destinationAddress1 = addressString;
        updatedData.contractInfo.detailInfo.destinationZipCode1 = data.zonecode;
        return updatedData;
      });
    } else if (addressType === "destination2") {
      setData((prev: any) => {
        const updatedData = { ...prev };
        updatedData.contractInfo.detailInfo.destinationAddress2 = addressString;
        updatedData.contractInfo.detailInfo.destinationZipCode2 = data.zonecode;
        return updatedData;
      });
    } else if (addressType === "destination3") {
      setData((prev: any) => {
        const updatedData = { ...prev };
        updatedData.contractInfo.detailInfo.destinationAddress3 = addressString;
        updatedData.contractInfo.detailInfo.destinationZipCode3 = data.zonecode;
        return updatedData;
      });
    }
  };

  return (
    <Wrapper>
      {isModalOpen && (
        <PostModalComponent
          onClose={postHandleCloseModal}
          postValueInput={postValueInput}
          addressType={addressType}
        />
      )}
      <Title>[고객사 정보]</Title>
      <InputBox>
        <CustomInputComponent
          label={"회사명"}
          placeholder={"회사명을 입력해주세요."}
          isRequired={true}
          value={data.contractInfo.clientInfo.companyName}
          name={"data.contractInfo.clientInfo.companyName"}
          onChangeInput={onChangeInput}
        ></CustomInputComponent>
        <CustomInputComponent
          label={"담당자명"}
          placeholder={"이름 + 직책"}
          isRequired={true}
          value={data.contractInfo.clientInfo.contactPerson}
          name={"data.contractInfo.clientInfo.contactPerson"}
          onChangeInput={onChangeInput}
        ></CustomInputComponent>
      </InputBox>
      <InputBox>
        <CustomInputComponent
          label={"전화번호"}
          placeholder={"담당자 연락처를 입력해주세요."}
          isRequired={true}
          value={data.contractInfo.clientInfo.contactNumber}
          name={"data.contractInfo.clientInfo.contactNumber"}
          onChangeInput={onChangeInput}
        ></CustomInputComponent>
        <CustomInputComponent
          label={"Email"}
          placeholder={"Email을 입력해주세요."}
          value={data.contractInfo.clientInfo.email}
          name={"data.contractInfo.clientInfo.email"}
          onChangeInput={onChangeInput}
        ></CustomInputComponent>
      </InputBox>

      <Title>[본사 정보]</Title>
      <InputBox>
        <CustomInputComponent
          label={"회사명"}
          placeholder={"회사명을 입력해주세요."}
          isRequired={true}
          value={data.contractInfo.headInfo.companyName}
          name={"data.contractInfo.headInfo.companyName"}
          onChangeInput={onChangeInput}
        ></CustomInputComponent>
        <CustomInputComponent
          label={"담당자명"}
          placeholder={"이름 + 직책"}
          isRequired={true}
          value={data.contractInfo.headInfo.contactPerson}
          name={"data.contractInfo.headInfo.contactPerson"}
          onChangeInput={onChangeInput}
        ></CustomInputComponent>
      </InputBox>
      <InputBox>
        <CustomInputComponent
          label={"전화번호"}
          placeholder={"담당자 연락처를 입력해주세요."}
          isRequired={true}
          value={data.contractInfo.headInfo.contactNumber}
          name={"data.contractInfo.headInfo.contactNumber"}
          onChangeInput={onChangeInput}
        ></CustomInputComponent>
        <CustomInputComponent
          label={"Email"}
          placeholder={"Email을 입력해주세요."}
          value={data.contractInfo.headInfo.email}
          name={"data.contractInfo.headInfo.email"}
          onChangeInput={onChangeInput}
        ></CustomInputComponent>
      </InputBox>

      <Title>[상세 정보]</Title>
      <InputBox>
        <CustomInputComponent
          label={"제목"}
          placeholder={"계약서의 제목을 입력하세요."}
          value={data.contractInfo.detailInfo.title}
          name={"data.contractInfo.detailInfo.title"}
          onChangeInput={onChangeInput}
        ></CustomInputComponent>
        <CustomInputComponent
          label={"직원수(명)"}
          placeholder={"직원수를 입력하세요."}
          value={data.contractInfo.detailInfo.totalEmployees}
          name={"data.contractInfo.detailInfo.totalEmployees"}
          onChangeInput={onChangeInput}
        ></CustomInputComponent>
      </InputBox>
      <InputBox>
        <EnterpriseDateInputComponent
          title={"작업날짜1"}
          dateData={data.contractInfo.detailInfo.workDate1}
          name={"data.contractInfo.detailInfo.workDate1"}
          setData={setData}
          isRequired={true}
        ></EnterpriseDateInputComponent>
        <EnterpriseDateInputComponent
          title={"작업날짜2"}
          dateData={data.contractInfo.detailInfo.workDate2}
          name={"data.contractInfo.detailInfo.workDate2"}
          setData={setData}
        ></EnterpriseDateInputComponent>
      </InputBox>
      <InputBox>
        <EnterpriseDateInputComponent
          title={"견적날짜"}
          dateData={data.contractInfo.detailInfo.contractDate}
          name={"data.contractInfo.detailInfo.contractDate"}
          setData={setData}
          isRequired={true}
        ></EnterpriseDateInputComponent>
        <CustomInputComponent
          label={"부대조건"}
          placeholder={"ex) 부가세 별도"}
          value={data.contractInfo.detailInfo.subCondition}
          name={"data.contractInfo.detailInfo.subCondition"}
          onChangeInput={onChangeInput}
        ></CustomInputComponent>
      </InputBox>
      <InputBox onClick={() => postHandleOpenModal("departure1")}>
        <CustomInputComponent
          label={"출발주소1"}
          placeholder={"출발 주소를 입력하세요."}
          isRequired={true}
          width={"100%"}
          value={`${data.contractInfo.detailInfo.departureAddress1} ${
            data.contractInfo.detailInfo.departureZipCode1
              ? `(${data.contractInfo.detailInfo.departureZipCode1})`
              : ""
          } `}
          name={"data.contractInfo.detailInfo.departureAddress1"}
          readOnly
        ></CustomInputComponent>
      </InputBox>
      <InputBox>
        <CustomInputComponent
          label={"출발주소1(상세)"}
          placeholder={"상세주소를 입력해주세요."}
          value={data.contractInfo.detailInfo.departureAddress1Detail}
          name={"data.contractInfo.detailInfo.departureAddress1Detail"}
          onChangeInput={onChangeInput}
          width={"100%"}
        ></CustomInputComponent>
      </InputBox>
      <InputBox onClick={() => postHandleOpenModal("destination1")}>
        <CustomInputComponent
          label={"도착주소1"}
          placeholder={"도착 주소를 입력하세요."}
          isRequired={true}
          width={"100%"}
          value={`${data.contractInfo.detailInfo.destinationAddress1} ${
            data.contractInfo.detailInfo.destinationZipCode1
              ? `(${data.contractInfo.detailInfo.destinationZipCode1})`
              : ""
          } `}
          // value={`${destinationAddress1}${
          //   afterZipCode1 ? `(${afterZipCode1})` : ""
          // }`}
          name={"data.contractInfo.detailInfo.destinationAddress1"}
          readOnly
        ></CustomInputComponent>
      </InputBox>
      <InputBox>
        <CustomInputComponent
          label={"도착주소1(상세)"}
          placeholder={"상세주소를 입력해주세요."}
          value={data.contractInfo.detailInfo.destinationAddress1Detail}
          name={"data.contractInfo.detailInfo.destinationAddress1Detail"}
          onChangeInput={onChangeInput}
          width={"100%"}
        ></CustomInputComponent>
      </InputBox>

      <FoldingBox $isExpanded={isAddressExpended}>
        <InputBox onClick={() => postHandleOpenModal("departure2")}>
          <CustomInputComponent
            label={"출발주소2"}
            placeholder={"출발 주소를 입력하세요."}
            isRequired={false}
            width={"100%"}
            value={`${data.contractInfo.detailInfo.departureAddress2} ${
              data.contractInfo.detailInfo.departureZipCode2
                ? `(${data.contractInfo.detailInfo.departureZipCode2})`
                : ""
            } `}
            name={"data.contractInfo.detailInfo.departureAddress2"}
            readOnly
          ></CustomInputComponent>
        </InputBox>
        <InputBox>
          <CustomInputComponent
            label={"출발주소2(상세)"}
            placeholder={"상세주소를 입력해주세요."}
            value={data.contractInfo.detailInfo.departureAddress2Detail}
            name={"data.contractInfo.detailInfo.departureAddress2Detail"}
            onChangeInput={onChangeInput}
            width={"100%"}
          ></CustomInputComponent>
        </InputBox>
        <InputBox onClick={() => postHandleOpenModal("destination2")}>
          <CustomInputComponent
            label={"도착주소2"}
            placeholder={"도착 주소를 입력하세요."}
            isRequired={false}
            width={"100%"}
            value={`${data.contractInfo.detailInfo.destinationAddress2} ${
              data.contractInfo.detailInfo.destinationZipCode2
                ? `(${data.contractInfo.detailInfo.destinationZipCode2})`
                : ""
            } `}
            name={"data.contractInfo.detailInfo.destinationAddress2"}
            readOnly
          ></CustomInputComponent>
        </InputBox>
        <InputBox>
          <CustomInputComponent
            label={"도착주소2(상세)"}
            placeholder={"상세주소를 입력해주세요."}
            value={data.contractInfo.detailInfo.destinationAddress2Detail}
            name={"data.contractInfo.detailInfo.destinationAddress2Detail"}
            onChangeInput={onChangeInput}
            width={"100%"}
          ></CustomInputComponent>
        </InputBox>

        <InputBox onClick={() => postHandleOpenModal("departure3")}>
          <CustomInputComponent
            label={"출발주소3"}
            placeholder={"출발 주소를 입력하세요."}
            isRequired={false}
            width={"100%"}
            value={`${data.contractInfo.detailInfo.departureAddress3} ${
              data.contractInfo.detailInfo.departureZipCode3
                ? `(${data.contractInfo.detailInfo.departureZipCode3})`
                : ""
            } `}
            name={"data.contractInfo.detailInfo.departureAddress3"}
            readOnly
          ></CustomInputComponent>
        </InputBox>
        <InputBox>
          <CustomInputComponent
            label={"출발주소3(상세)"}
            placeholder={"상세주소를 입력해주세요."}
            value={data.contractInfo.detailInfo.departureAddress3Detail}
            name={"data.contractInfo.detailInfo.departureAddress3Detail"}
            onChangeInput={onChangeInput}
            width={"100%"}
          ></CustomInputComponent>
        </InputBox>
        <InputBox onClick={() => postHandleOpenModal("destination3")}>
          <CustomInputComponent
            label={"도착주소3"}
            placeholder={"도착 주소를 입력하세요."}
            isRequired={false}
            width={"100%"}
            value={`${data.contractInfo.detailInfo.destinationAddress3} ${
              data.contractInfo.detailInfo.destinationZipCode3
                ? `(${data.contractInfo.detailInfo.destinationZipCode3})`
                : ""
            } `}
            name={"data.contractInfo.detailInfo.destinationAddress3"}
            readOnly
          ></CustomInputComponent>
        </InputBox>
        <InputBox>
          <CustomInputComponent
            label={"도착주소3(상세)"}
            placeholder={"상세주소를 입력해주세요."}
            value={data.contractInfo.detailInfo.destinationAddress3Detail}
            name={"data.contractInfo.detailInfo.destinationAddress3Detail"}
            onChangeInput={onChangeInput}
            width={"100%"}
          ></CustomInputComponent>
        </InputBox>
      </FoldingBox>
      <FoldingButton onClick={handleFoldingButton}>
        {isAddressExpended ? "추가 주소 접기" : "추가 주소 펼치기"}
      </FoldingButton>
      <InputBox>
        <CustomInputComponent
          label={"상세작업내역1"}
          placeholder={"작업내역을 입력하세요."}
          isTextArea={true}
          value={data.contractInfo.detailInfo.workCondition1}
          name={"data.contractInfo.detailInfo.workCondition1"}
          onChangeInput={onChangeInput}
        ></CustomInputComponent>
        <CustomInputComponent
          label={"상세작업내역2"}
          placeholder={"작업내역을 입력하세요."}
          isTextArea={true}
          value={data.contractInfo.detailInfo.workCondition2}
          name={"data.contractInfo.detailInfo.workCondition2"}
          onChangeInput={onChangeInput}
        ></CustomInputComponent>
      </InputBox>
    </Wrapper>
  );
}
